import ExitScanner from './ExitScanner';

export default ExitScanner;
